export { default } from '../../../menu/(menu)/index';
export * from '../../../menu/(menu)/index';
